import { OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { Subject } from "rxjs";

@Pipe({
  name: "filter",
})
export class FilterPipe implements PipeTransform,OnDestroy {
  private destroy$ = new Subject<void>();
  transform(value: any[], ...args: any[]): unknown {
    if (!value || !args || !args[0]) {
      return value;
    }
    
    return value.filter(item => item[args[0]] === args[1]);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
